module.exports = __webpack_public_path__ + "static/media/6_School of the animals_SE.f82ba008.txt";